module.exports = __webpack_public_path__ + "static/media/map.226c3017.png";